import React from 'react';
import MediaSelector, {
  Props as MediaSelectorProps,
} from '../../MediaSelector/MediaSelector';
import { useCurrentMediaSource } from '../../_hocs/withCurrentMediaSource';
import { MediaSourceType } from '../../types';
import { DeviationResourceType } from '../../../types/deviation';
import { useFilterProps } from '../../_hocs/withFilter';
import { useGruser } from '../../_hocs/withGruser';
import { DEFAULT_MEDIASOURCE_TYPES_FOR_MEDIA_SELECTOR } from '../../constants';

import innerMediaSelectorStyles from './InnerMediaSelector.scss';

export type Props = Pick<
  MediaSelectorProps,
  | 'onSelect'
  | 'onClose'
  | 'selectionLimit'
  | 'title'
  | 'submitBtnLabel'
  | 'ignoreDeviationIds'
>;

const InnerMediaSelector: React.FC<Props> = ({
  selectionLimit,
  onSelect,
  onClose,
  title,
  submitBtnLabel,
}) => {
  const { currentMediaSource, mediaSourceTypes, withMediaSourceSelector } =
    useCurrentMediaSource();
  const {
    allowedDeviationTypes,
    allowedDeviationResourceTypes,
    allowGifs,
    allowInTierContent,
    ignoreDeviationIds,
  } = useFilterProps();
  const { gruser } = useGruser();

  return (
    <MediaSelector
      gruser={gruser}
      initialMediaSource={currentMediaSource}
      mediaSourceTypes={mediaSourceTypes}
      withMediaSourceSelector={withMediaSourceSelector}
      allowedDeviationTypes={allowedDeviationTypes}
      allowedDeviationResourceTypes={allowedDeviationResourceTypes}
      allowGifs={allowGifs}
      allowInTierContent={
        (currentMediaSource &&
          [
            MediaSourceType.TIER_DEVIATIONS,
            MediaSourceType.TIER_POSTS,
          ].includes(currentMediaSource)) ||
        allowInTierContent
      }
      ignoreDeviationIds={ignoreDeviationIds}
      selectionLimit={selectionLimit}
      contentClassName={innerMediaSelectorStyles['content']}
      overlayClassName={innerMediaSelectorStyles['add-deviations-overlay']}
      onSelect={onSelect}
      onClose={onClose}
      title={title}
      submitBtnLabel={submitBtnLabel}
      {...{
        [MediaSourceType.CUSTOM_SET]: {
          withMediaSourceSelector: true,
          initialMediaSource: mediaSourceTypes?.[0],
          mediaSourceTypes: DEFAULT_MEDIASOURCE_TYPES_FOR_MEDIA_SELECTOR,
        },
        [MediaSourceType.TIER_DEVIATIONS]: {
          initialMediaSource: MediaSourceType.GALLERY,
          mediaSourceTypes: [
            MediaSourceType.GALLERY,
            MediaSourceType.TIER_DEVIATIONS,
          ],
          withMediaSourceSelector: true,
          allowUploads: false,
        },
        [MediaSourceType.TIER_POSTS]: {
          initialMediaSource: MediaSourceType.POSTS,
          mediaSourceTypes: [MediaSourceType.POSTS, MediaSourceType.TIER_POSTS],
          allowedDeviationResourceTypes: [
            DeviationResourceType.JOURNAL,
            DeviationResourceType.STATUS_DEVIATION,
          ],
          withMediaSourceSelector: true,
          allowUploads: false,
        },
      }[currentMediaSource ?? '']}
    />
  );
};
InnerMediaSelector.displayName = 'InnerMediaSelector';

export default InnerMediaSelector;
